import { forwardRef } from "react";
import type { LucideIcon, LucideProps } from "lucide-react";

/**
 * The lucide `Megaphone` glyph as drawn in lucide-react 1.47.0. Our installed
 * 0.511.0 ships the older flat-cone drawing under the same name, so the paths
 * are vendored here. A plain SVG rather than `createLucideIcon`, because app
 * tests replace `lucide-react` with whitelist mocks that carry no factory.
 * Delete this file and import `MegaphoneIcon` once lucide-react is on 1.x.
 */
const AdsIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(
  (
    { size = 24, color = "currentColor", strokeWidth = 2, className, ...rest },
    ref
  ) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...rest}
    >
      <path d="M11 6a13 13 0 0 0 8.4-2.8A1 1 0 0 1 21 4v12a1 1 0 0 1-1.6.8A13 13 0 0 0 11 14H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z" />
      <path d="M6 14a12 12 0 0 0 2.4 7.2 2 2 0 0 0 3.2-2.4A8 8 0 0 1 10 14" />
      <path d="M8 6v8" />
    </svg>
  )
);

AdsIcon.displayName = "AdsIcon";

export default AdsIcon;
